import React from "react";

import { Box, Typography, Paper } from "@mui/material";

import { config, styles } from "../../style";

export const ErrorScreen = (props) => {
    return (
        <Paper sx={{ mt: "16px", p: "1rem" }} elevation={1}>
            <Typography sx={{ ...styles.cardHeading }}>No results... :(</Typography>
            <Typography sx={{ ...styles.subHeading, mt: "1rem" }}>
                Here’s what you can do for results to appear:
            </Typography>
            <ul style={{ marginLeft: "1.5rem", marginTop: ".5rem" }}>
                <li>
                    <Typography sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize }}>
                        Zoom out
                    </Typography>
                </li>
                <li>
                    <Typography sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize }}>
                        Clear the map boundary
                    </Typography>
                </li>
                <li>
                    <Typography
                        component="span"
                        sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize, display: "inline" }}
                    >
                        Reset all filters{" "}
                        <span style={{ ...styles.subHeading, display: "inline", fontWeight: "400" }}>or</span> remove{" "}
                        <span style={{ ...styles.subHeading, display: "inline", fontWeight: "400" }}>
                            one of them below until you see more homes
                        </span>
                    </Typography>
                </li>
            </ul>
        </Paper>
    );
};
